import { validate } from './validator.js';

const validateEntryPagesTrackingPayload = (eventName, properties, schema, logger) => {
  const { valid, errors } = validate(properties, schema);
  if (!valid) {
    logger.error(`Validation failed for tracking event ${eventName}`, { errors });
  }
};

export { validateEntryPagesTrackingPayload };
//# sourceMappingURL=validate.js.map
